import './bootstrap';

// Composant jquery-ui
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';

// datetime management
window.dayjs = require('dayjs');